import Spinner from '@ui-components-3/icons/lib/solid/SpinnerThird'

type Props = {
  loading: boolean
  testId?: string
}

const Loading = (props: Props): JSX.Element => {
  const { loading, testId } = props

  if (!loading) return <></>

  return (
    <div className="fixed left-0 top-0 z-50 flex h-screen w-screen items-center justify-center backdrop-grayscale backdrop-opacity-30">
      <div role="status" data-testid={testId}>
        <Spinner className="h-10 w-10 animate-spin fill-neutral-100" />
      </div>
    </div>
  )
}

export default Loading
